import { portalApi } from "./client";

// SP-2b — portal-side client + DTO types for the per-loan monthly cycle
// mirror the TPS sees inside its Loans tab. Mirrors the C# record the
// backend exposes under /api/portal/tps/loans/{loanId}/monthly-cycle.
// Kept inside the portal bundle so nothing here imports staff types. No
// React Query in the portal — callers load with useState.

export type TpsCycleStepKey =
  | "statement"
  | "phoenix-review"
  | "tps-review"
  | "borrower-pays"
  | "payment-recorded"
  | "payout"
  | "complete";

export type TpsCycleStepState = "done" | "active" | "blocked" | "upcoming";

export interface TpsCycleStep {
  key: TpsCycleStepKey;
  state: TpsCycleStepState;
  at: string | null;
}

export interface TpsCycleStatement {
  id: string;
  status: string;
  amountDue: number;
  preparedAt: string | null;
  postedAt: string | null;
  returnedReason: string | null;
}

export interface TpsCyclePayment {
  id: string;
  status: string;
  method: string | null;
  amount: number;
  processingAt: string | null;
  clearedAt: string | null;
  returnedAt: string | null;
  failureReason: string | null;
}

export interface TpsCycleServicingPayment {
  amount: number;
  paymentDate: string;
  isReversed: boolean;
}

export interface TpsCycleDistribution {
  id: string;
  status: string;
  totalAmount: number;
  approvedAt: string | null;
  blockReason: string | null;
}

export interface TpsMonthlyCycle {
  /** "YYYY-MM". */
  period: string;
  periodStart: string;
  periodEnd: string;
  dueDate: string | null;
  expectedAmount: number | null;
  /** The selectable "YYYY-MM" periods for the month picker. */
  availablePeriods: string[];
  statement: TpsCycleStatement | null;
  payment: TpsCyclePayment | null;
  servicingPayment: TpsCycleServicingPayment | null;
  distribution: TpsCycleDistribution | null;
  steps: TpsCycleStep[];
}

export const tpsCycleApi = {
  /** The cycle for `period` ("YYYY-MM"), or the current period when omitted. */
  get: (loanId: string, period?: string) =>
    portalApi.get<TpsMonthlyCycle>(
      `/tps/loans/${loanId}/monthly-cycle`,
      period ? { period } : undefined,
    ),
};
